<template>
    <div id="notes">
        <div class="toggle-outline dropdown">
            <a class="nav-link pointer" :class="{disabled: !selected || !selected.id}" @click.prevent="showOutline()" data-toggle="dropdown">
                <span class="d-inline-block my-1">
                    <i class="fas fa-chevron-circle-down"></i>
                </span>
            </a>
            <div class="dropdown-menu dropdown-menu-right" :class="{fullpage: fullpage}">
                <a href="#" class="dropdown-item" :style="{
                    paddingLeft: (v.level) + 'rem',
                }" :class="{'font-weight-bold': v.level == 1}" v-for="(v, i) in outline" :key="i"
                    @click.prevent="scrollTo(v)">
                    {{$filters.truncate(v.caption, 20)}}
                </a>
            </div>
        </div>
        <ul class="nav nav-tabs mx-3">
            <li class="nav-item note-finder">
                <a class="nav-link pointer" @click.prevent="showSearch()">
                    <span class="d-inline-block my-1">
                        <i class="fas fa-ban text-danger" v-if="timeoutID"></i>
                        <i class="fas fa-search" v-else></i>
                    </span>
                </a>
            </li>
            <li class="nav-item note-caption" v-if="book">
                <a class="nav-link pointer px-2" :class="{active: isActive(undefined)}" @click.prevent="selectNote(null)">
                    <span class="d-inline-block my-1">
                        <i class="fas fa-book"></i>
                        小説情報
                    </span>
                </a>
            </li>
            <li class="nav-item note-caption" v-for="(n, i) in notes" :key="n.id">
                <a class="nav-link pointer px-2" :class="{active: isActive(n.id)}" @click.prevent="selectNote(i)">
                    <button type="button"
                        class="btn btn-light btn-sm p-1"
                        @click.prevent="editCaption(n)"
                        v-if="isActive(n.id) && n.id && (edit !== n.id)">
                        <i class="fas fa-edit mx-1"></i>
                    </button>
                    <div class="input-group" v-if="isActive(n.id) && edit === n.id">
                        <div class="input-group-prepend">
                            <button type="button" class="btn btn-light btn-sm" @click="cancelEdit()">
                                <i class="fas fa-times"></i>
                            </button>
                        </div>
                        <input type="text" :id="'edit-caption-' + n.id" class="form-control" v-model="selected.caption" @keydown.enter="saveNote($event)">
                        <div class="input-group-append">
                            <button type="button" class="btn btn-light btn-sm" @click="saveNote()">
                                <i class="fas fa-check"></i>
                            </button>
                        </div>
                    </div>
                    <span class="d-inline-block my-1" v-else>
                        {{n.caption}}
                        <i class="fas fa-edit text-danger" v-if="n.status === -1"></i>
                        <i class="fas fa-spinner fa-spin" v-else-if="n.status === 1"></i>
                        <i class="fas fa-check-circle text-success" v-else></i>
                    </span>
                </a>
            </li>
        </ul>
        <div v-if="selected">
            <div class="flextext"
                :class="{fullpage: fullpage}"
                v-if="selected && selected.id">
                <editor :content="$filters.jsonParse(selected.memo)"
                    ref="editor"
                    class="note-editor"
                    :class="{fullpage: fullpage}"
                    :keyword="keyword"
                    :readOnly="readOnly"
                    @clickedOnReadOnly="clearFound()"
                    @change="autoSaving($event)"
                    @ready="ready()"></editor>
            </div>
            <div class="mx-4 py-4" v-else>
                <div class="input-group">
                    <div class="input-group-prepend">
                        <span class="input-group-text">
                            見出し
                            &nbsp;
                            <span class="small">
                                <span v-if="caption">{{caption.length}}</span>
                                <span v-else>0</span>
                                / 16文字
                            </span>
                        </span>
                    </div>
                    <input type="text" class="form-control"
                        placeholder="例）プロット、登場人物、設定"
                        @keydown.enter="addNote($event)"
                        maxlength="16"
                        v-model="caption">
                    <div class="input-group-append">
                        <button type="button" class="btn btn-secondary btn-sm" @click="addNote()">
                            <i class="fas fa-plus"></i>
                            追加
                        </button>
                    </div>
                </div>
                <div class="text-muted small">
                    ノートは {{$store.state.max_notes}} ページまで追加することができます。
                </div>
                <div class="row" v-if="stickies">
                    <div class="col-md-6 p-3" v-for="s in stickies.data" :key="s.id">
                        <div class="card h-100">
                            <div class="card-header d-flex justify-content-between">
                                <div> {{s.caption}} </div>
                                <button class="btn btn-light btn-sm" @click="appendNote(s.id)">
                                    <i class="fas fa-plus"></i>
                                </button>
                            </div>
                            <div class="card-body small" v-html="thumbnail(s)"></div>
                        </div>
                    </div>
                </div>
                <div class="row d-flex justify-content-center" v-if="this.page < this.stickies.last_page">
                    <button class="btn btn-light" type="button" @click="lazyLoad()">
                        もっと読み込む...
                    </button>
                </div>
            </div>
            <div class="m-4" v-if="selected && selected.id">
                <div class="row">
                    <div class="col-4">
                        <div class="btn-group" role="group">
                            <button type="button" class="btn btn-outline-secondary btn-sm" @click="backword()" :disabled="!backwordable">
                                <i class="fas fa-chevron-left"></i>
                            </button>
                            <button type="button" class="btn btn-outline-secondary btn-sm" @click="forward()" :disabled="!forwardable">
                                <i class="fas fa-chevron-right"></i>
                            </button>
                        </div>
                    </div>
                    <div class="col-4 text-center">
                        <editor-storage :content="selected.memo"></editor-storage>
                    </div>
                    <div class="col-4 text-right">
                        <button type="button" class="btn btn-outline-warning btn-sm" @click="remove()">
                            <i class="fas fa-unlink d-sm-block d-md-none"></i>
                            <span class="d-none d-md-block">
                                <i class="fas fa-unlink"></i>
                                ノートを外す
                            </span>
                        </button>
                    </div>
                </div>
            </div>
        </div>
        <div v-else-if="book">
            <div class="mx-3">
                <div class="form-group" v-if="book.subtitle">
                    <h5 class="m-2 mt-4">サブタイトル</h5>
                    <p class="pane">{{book.subtitle}}</p>
                </div>
                <div class="form-group">
                    <h5 class="m-2 mt-4">紹介文</h5>
                    <p class="pane" v-html="$filters.wrap(book.description)"></p>
                </div>
                <div class="form-group" v-if="book.tags && book.tags.length">
                    <h5 class="m-2 mt-4">タグ</h5>
                    <ul class="tag-list pane">
                        <li v-for="t in book.tags" :key="t.id">
                            <router-link :to="'/search?keywords=' + encodeURI(t.tag_name)" class="black">{{t.tag_name}}</router-link>
                        </li>
                    </ul>
                </div>
                <div class="row mt-4">
                    <div class="col-6">
                        <router-link :to="`/mypage/book/${book_id}/edit`" class="btn btn-outline-primary btn-block">
                            <i class="fas fa-edit"></i>
                            小説情報編集
                        </router-link>
                    </div>
                    <div class="col-6">
                        <router-link :to="`/mypage/book/${book_id}/sections`" class="btn btn-outline-success btn-block">
                            <i class="fas fa-list"></i>
                            本文一覧
                        </router-link>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<style scoped lang="scss">
.nav-tabs {
    overflow-x: auto;
    overflow-y: hidden;
    display: flex;
    flex-wrap: nowrap;
    -ms-overflow-style: none;
    scrollbar-width: none;
    &::-webkit-scrollbar{
        display: none;
    }
    li {
        min-width: 50px;
        flex-shrink: 0;
    }
}
.note-caption {
    font-size: .9rem;
    min-width: 5rem;
}
.note-finder {
    font-size: .9rem;
    max-width: .9rem;
}
#notes {
    position: relative;
}
.toggle-outline {
    position: absolute;
    top: 0;
    right: 10px;
    border-radius: .3rem .3rem 0 0;
    border: 1px solid #ddd;
    border-bottom: 0;
    background-color: rgba(255, 255, 255, .6);
}
$fullpage-height: calc(100vh - 187px);
$sidebar-height: calc(100vh - 275px);
.dropdown-menu {
    max-height: $sidebar-height;
    overflow-y: auto;
    -ms-overflow-style: none;
    scrollbar-width: none;
    &.fullpage {
        max-height: $fullpage-height;
    }
    &::-webkit-scrollbar{
        display:none;
    }
}
.flextext {
    position: relative;
    width: 100%;
    margin: 0;
    height: $sidebar-height;
    padding: 0;
    &.fullpage {
        height: $fullpage-height;
    }
    #block-editor {
        overflow: scroll;
        -ms-overflow-style: none;
        scrollbar-width: none;
        &::-webkit-scrollbar{
            display:none;
        }
        height: $sidebar-height;
        &.fullpage {
            height: $fullpage-height;
        }
    }
    font-size: .9rem;
    .textarea {
        position: absolute;
        top: 0;
        left: 0;
        height: $sidebar-height;
        padding-bottom: 5rem;
        background-color: #f1f2f3;
        &.fullpage {
            height: $fullpage-height;
        }
        &:read-only {
            background-color: #dde6e6;
        }
    }
}
.pane {
    padding: 1rem;
    border-radius: .5rem;
}
</style>

<script>
export default {
    props: {
        book_id: {
            required: true,
        },
        fullpage: {
            default: false
        },
        focus: {
            default: false,
        },
        book: {
            default: null,
        },
    },
    data() {
        return {
            notes: [],
            stickies: [],       // 独立ノート
            page: 1,            // 独立ノートページ
            selected: null,
            caption: null,      // 新規ノート見出し
            selected: null,     // 現在選択中のノート
            edit: null,         // 見出し編集状態フラグ
            timeoutID: null,    // ノート自動保存ID
            sortingID: null,    // 並び替え自動保存ID
            keyword: null,      // 検索文字列
            outline: [],        // アウトライン情報
            readOnly: false,
        }
    },
    methods: {
        load(s = null, init = false) {
            axios.get("/mypage/book/notes", {params: {book_id: this.book_id}}).then(res => {
                this.keyword = null;
                for (let d of res.data) {
                    d.status = 0;
                }
                let status = [];
                if (this.notes) {
                    for (const note of this.notes) {
                        status.push({
                            id: note.id,
                            scrollTop: note.scrollTop
                        });
                    }
                }
                this.notes = res.data;
                if (status.length > 0) {
                    for (const note of this.notes) {
                        const stat = _.find(status, {id: note.id});
                        if (stat) {
                            note.scrollTop = stat.scrollTop;
                        }
                    }
                }
                if (s) {
                    this.selected = s;
                } else if (this.notes.length) {
                    if (!this.selected) {
                        this.selected = this.notes[0];
                    } else if (!this.selected.id) {
                        this.selected = this.notes[this.notes.length - 1];
                    } else {
                        this.selected = _.find(this.notes, {id: this.selected.id});
                    }
                }
                if (!this.notes || this.notes.length < this.$store.state.max_notes) {
                    this.notes.push({
                        id: 0,
                        book_id: this.book_id,
                        caption: "新規ノート",
                        memo: null,
                        status: 0,
                        order_number: 0
                    });
                    if (!this.selected) {
                        this.selected = this.notes[0];
                    }
                }
                if (init) {
                    setTimeout(() => {
                        if (this.$refs.editor) {
                            this.$refs.editor.refresh();
                        }
                    });
                }
            }).catch(err => { alert.err(err) });
        },
        lazyLoad() {
            this.page++;
            setTimeout(() => this.loadStickies());
        },
        loadStickies() {
            axios.get("/mypage/book/notes", {params: {page: this.page}}).then(res => {
                if (this.page > 1) {
                    for (const s of res.data.data) {
                        this.stickies.data.push(s);
                    }
                    this.stickies.current_page = this.page;
                } else {
                    this.stickies = res.data
                }
            }).catch(err => { alert.err(err.response) });
        },
        // ノートの新規追加
        addNote(ev = null) {
            if (ev && ev.keyCode !== 13) return;
            if (!this.caption) return;
            let note = {
                book_id: this.book_id,
                caption: this.caption,
                memo: null,
            };
            this.caption = null;
            $("#add-memo").dropdown("toggle");
            this.save(note);
        },
        // 既存ノートの追加
        appendNote(id) {
            axios.post("/mypage/book/note/append", {
                id: id,
                book_id: this.book_id
            }).then(res => {
                this.load();
                this.loadStickies();
            });
        },
        // 既存ノートの保存
        saveNote(ev = null) {
            if (ev && ev.keyCode !== 13) return;
            this.save(this.selected);
            this.edit = null;
        },
        // 任意の保存処理・第２引数は保存後のクロージャ
        async save(n, s = null) {
            n.status = 1;
            if (this.$refs.editor && (!n.id || n.id === this.selected.id)) {
                const save_data = await this.$refs.editor.save();
                n.memo = JSON.stringify(save_data).replace(/<span[^>]*>/mug, "").replace(/<\/span>/mug, "");
            }
            this.__save(n).then(res => {
                n.status = 0;
                this.timeoutID = null;
                if (!n.last) {
                    this.load();
                }
                if (s) {s();}
            }).catch(err => { alert.err(err) });
        },
        __save(n) {
            return axios.post("/mypage/book/note/save", n);
        },
        ready() {
            const editor = document.getElementById("block-editor");
            editor.addEventListener("focusout", (e) => {
                if (this.timeoutID) {
                    clearTimeout(this.timeoutID);
                    this.timeoutID = null;
                    this.save(this.selected);
                }
            });
        },
        selectNote(n, callback = null) {
            if (this.edit || this.selected?.status > 0) return;
            if (this.timeoutID) {
                // 未保存の場合、即座に保存してしまう
                clearTimeout(this.timeoutID);
                this.timeoutID = null;
                this.save(this.selected, () => {
                    this.selectNote(n, callback);
                });
            } else {
                // 現在のパネルのステータス保存
                const note = _.find(this.notes, {id: this.selected?.id});
                if (note) {
                    note.scrollTop = $("#block-editor").scrollTop();
                }
                // 新規パネルのステータス復帰
                this.selected = this.notes[n];
                setTimeout(() => {
                    if (this.$refs.editor) {
                        this.$refs.editor.refresh(() => {
                            $("#block-editor")[0].scrollTop = this.selected.scrollTop || 0;
                            if (callback) {
                                callback();
                            }
                        });
                    }
                });
            }
        },
        isActive(id) {
            return this.selected?.id === id;
        },
        editCaption(n) {
            if (this.edit) return;
            this.selected = n;
            this.edit = n.id;
            setTimeout(() => {$("#edit-caption-" + n.id).select()});
        },
        cancelEdit() {
            this.edit = null;
        },
        // 自動保存
        autoSaving(ev) {
            if (ev.type === "block-changed" && ev.detail.target.name === "image") {
                const save_data = this.$refs.editor.save();
                if (this.selected.memo) {
                    // SimpleImageのonChange()バグ対応
                    try {
                        const org_memo = JSON.parse(this.selected.memo);
                        const org_blocks = JSON.stringify(_.find(org_memo.blocks, {id: ev.detail.target.id}));
                        const new_blocks = JSON.stringify(_.find(save_data.blocks, {id: ev.detail.target.id}));
                        if (org_blocks == new_blocks) {
                            return;
                        }
                    } catch (error) {
                    }
                }
            }
            if (this.timeoutID) {
                clearTimeout(this.timeoutID);
                this.timeoutID = null;
            }
            this.selected.status = -1;
            this.timeoutID = setTimeout(this.save,
                (this.selected?.memo?.length || 0) < 10000 ? 10000 : this.selected.memo.length,
                this.selected);
        },
        remove() {
            if (!this.selected.id) {
                return;
            }
            Swal.fire({
                title: "ノートを外す",
                html: `<div class="text-left small">
                    <p>
                        ノート「${this.selected.caption}」をこの小説から外します。<br>
                        外したノートはノート一覧に移動します。
                        完全に削除するためには、ノート一覧で削除する必要があります。
                    </p>
                    <p>
                        よろしいですか？
                    </p>
                    </div>`,
                icon: "warning",
                showCancelButton: true,
                confirmButtonText: "ノートを外す",
                cancelButtonText: "キャンセル",
                confirmButtonColor: "#ddb700",
                cancelButtonColor: "gray",
                reverseButtons: true,
            }).then(confirm => {
                if (confirm.isConfirmed) {
                    axios.post("/mypage/book/note/unlink", {id: this.selected.id}).then(res => {
                        this.selected = null;
                        this.load();
                        this.loadStickies();
                    }).catch(err => { alert.err(err.response) });
                }
            });
        },
        backword() {
            if (!this.backwordable) return;
            const i = _.findIndex(this.notes, {id: this.selected.id});
            this.notes.splice(i -1, 2, this.notes[i], this.notes[i - 1]);
            this.sorting();
        },
        forward() {
            if (!this.forwardable) return;
            const i = _.findIndex(this.notes, {id: this.selected.id});
            this.notes.splice(i, 2, this.notes[i + 1], this.notes[i]);
            this.sorting();
        },
        sorting() {
            if (this.sortingID) {
                clearTimeout(this.sortingID);
                this.sortingID = null;
            }
            this.sortingID = setTimeout(() => {this.sort()}, 1000);
        },
        sort() {
            axios.post("/mypage/book/notes/sort", {notes: this.notes}).catch(err => { alert.err(err.response) });
        },
        replaceKeyword(words) {
            if (!words.keyword) return;
            if (this.timeoutID) {
                // 未保存の場合、即座に保存してしまう
                clearTimeout(this.timeoutID);
                this.timeoutID = null;
                this.save(this.selected, () => {
                    this.replaceKeyword();
                });
                return;
            }
            // すべてのノートを置換する
            let regex = new RegExp(words.keyword.replace(/[\\^$.*+?()[\]{}|]/g, '\\$&'), "gm");
            for (const ndx in this.notes) {
                const n = this.notes[ndx];
                if (!n.memo) continue;
                try {
                    const memo = JSON.parse(n.memo);
                    for (const b in memo.blocks) {
                        const block = memo.blocks[b];
                        if (block.data.text) {
                            // 本文とヘッダ
                            block.data.text = block.data.text.replace(regex, words.replace);
                        } else if (block.data.items) {
                            // リスト
                            for (const i in block.data.items) {
                                block.data.items[i] = block.data.items[i].replace(regex, words.replace);
                            }
                        } else if (block.data.content) {
                            for (const r in block.data.content) {
                                const row = block.data.content[r];
                                for (const c in row) {
                                    row[c] = row[c].replace(regex, words.replace);
                                }
                            }
                        } else if (block.data.caption) {
                            block.data.caption = block.data.caption.replace(regex, words.replace);
                        }
                    }
                    n.memo = JSON.stringify(memo);
                } catch (error) {
                    // 旧バージョンフォーマット対応
                    n.memo = n.memo.replace(regex, words.replace);
                }
            }
            axios.post("/mypage/book/notes/save", {notes: this.notes}).then(res => {
                this.load(null, true);
            }).catch(err => { alert.err(err.response) });
        },
        async showOutline() {
            if (!this.selected) return;
            const note = await this.$refs.editor.save();
            this.outline = [];
            this.outline.push({
                caption: "先頭",
                id: "start",
                level: 1,
            });
            for (const index in note.blocks) {
                const block = note.blocks[index];
                if (block.type === "header") {
                    this.outline.push({
                        id: block.id,
                        caption: block.data.text.replace(/<[^>]+>/gm, ""),
                        level: block.data.level,
                        index: index,
                    });
                }
            }
            this.outline.push({
                caption: "末尾",
                id: "end",
                level: 1,
            });
            return;
        },
        thumbnail(n) {
            let strings = [];
            if (n.memo) {
                try {
                    const memo = JSON.parse(n.memo);
                    for (const block of memo.blocks) {
                        if (block.data.text) {
                            // 本文とヘッダ
                            strings.push(block.data.text);
                        } else if (block.data.items) {
                            // リスト
                            for (const item of block.data.items) {
                                strings.push(items);
                            }
                        } else if (block.data.content) {
                            for (const row of block.data.content) {
                                for (const cell of row) {
                                    strings.push(cell);
                                }
                            }
                        } else if (block.data.caption) {
                            strings.push(block.data.caption);
                        }
                    }
                } catch (error) {
                    strings = n.memo.split("\n");
                }
            }
            return (this.$filters.truncate(strings.join("\n"), 350)).replace(/\n/g, "<br>");
        },
        scrollTo(v) {
            let scrollTop = 0;
            if (!v.index) {
                if (v.caption === "末尾") {
                    scrollTop = $("#block-editor")[0].scrollHeight;
                }
            } else {
                const x = parseInt(v.index) + 1;
                scrollTop = $("#block-editor .ce-block:nth-child(" + x + ")")[0].offsetTop;
            }
            $("#block-editor").animate({scrollTop: scrollTop});
        },
        showSearch() {
            if (!this.timeoutID) {
                this.$emit('searchNote');
            }
        },
        found(result) {
            let n = null;
            for (const index in this.notes) {
                if (this.notes[index].id == result.id) {
                    n = index;
                    break;
                }
            }
            if (n) {
                this.selectNote(n, () => {
                    this.scrollTo(result);
                    this.readOnly = true;
                    this.keyword = result.keyword;
                    setTimeout(() => {
                        this.$refs.editor.refresh();
                    });
                });
            }
        },
        clearFound() {
            this.readOnly = false;
            this.keyword = null;
            setTimeout(() => {
                this.$refs.editor.refresh();
            });
        },
    },
    watch: {
        book_id(n, o) {
            this.load(null, true);
        }
    },
    computed: {
        forwardable() {
            if (!this.selected?.id) return false;
            const i = _.findIndex(this.notes, {id: this.selected.id});
            let diff = 1;
            if (!this.notes[this.notes.length - 1]?.id) {
                diff = 2;
            }
            if (i === this.notes.length - diff) return false;
            return true;
        },
        backwordable() {
            if (!this.selected?.id) return false;
            const i = _.findIndex(this.notes, {id: this.selected.id});
            if (!i) return false;
            return true;
        },
    },
    mounted() {
        this.load(null, true);
        this.loadStickies();
    },
    async beforeDestroy() {
        if (this.timeoutID) {
            clearTimeout(this.timeoutID);
            this.selected.last = true;
            await this.save(this.selected);
        }
    }
}
</script>